import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {FormService} from '../../../services/formServices';
import {Categoria} from "../../../domain/categorias";
import {Estado} from '../../../domain/estado';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit {
    @Input('id')id: number;
    @Input('disable')_disable:boolean;
    @Output('selected')selected = new EventEmitter<number>();
    main: Array<any>;
    selectedValue: number;
    disable: boolean;
    constructor(private formService: FormService, private toast: ToastrService) { }

    ngOnInit(): void {
        this.disable = this._disable;
        this.formService.getSistemasPropios().subscribe(
            data => {
                this.main = data;
                this.selectedValue = this.id;
            }
        );
    }

    onChange() {
        if(this.selectedValue === 0){
            this.toast.error('Seleccionar una opción valida', 'Error');
        } else {
            this.selected.emit(this.selectedValue);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/selects/select/select.component.ts